/**
 * Simple SVG line chart for score-over-time trends. No external chart lib.
 * Values are normalized to 0–100 for display; props.values are numbers (e.g. snapshot scores).
 */
import React from 'react';

export function SimpleLineChart({ values = [], width = 280, height = 80, strokeColor = 'var(--amber)', caption }) {
  if (!values.length) {
    return (
      <div className="analytics-line-chart">
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none meet">
          <text x={width / 2} y={height / 2} textAnchor="middle" fill="var(--muted)" fontSize="12">
            No data yet
          </text>
        </svg>
        {caption && <p className="analytics-line-chart-caption">{caption}</p>}
      </div>
    );
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const padding = { top: 8, right: 8, bottom: 8, left: 8 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const points = values.map((v, i) => {
    const x = padding.left + (i / Math.max(1, values.length - 1)) * chartWidth;
    const y = padding.top + chartHeight - ((v - min) / range) * chartHeight;
    return `${x},${y}`;
  }).join(' ');
  return (
    <div className="analytics-line-chart">
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none meet">
        <polyline
          fill="none"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          points={points}
        />
      </svg>
      {caption && <p className="analytics-line-chart-caption">{caption}</p>}
    </div>
  );
}
